import styled from 'styled-components';
import { spacing } from 'ui/theme';

export const Wrapper = styled.div`
  padding: ${spacing.base};
  height: 100%;
`;

const FooterWrapper = styled.div`
  display: flex;
  width: 100%;
`;

export const EditorFooterWrapper = styled(FooterWrapper)`
  justify-content: space-between;
`;

export const DefaultFooterWrapper = styled(FooterWrapper)`
  justify-content: flex-end;
`;

export const StyledButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;
